import { useTranslation } from "react-i18next";
import { getLocale } from "../../i18n";
import { de as deDateLocale, enGB as enDateLocale } from "date-fns/locale";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export function Calendar({ date, onChange, maxDate, weekStartsOn }) {
  useTranslation();
  return (
    <DatePicker locale={getLocale() === "de-DE" ? deDateLocale : enDateLocale}
      inline
      selected={date}
      onChange={onChange}
      maxDate={maxDate}
      calendarStartDay={weekStartsOn}
    />
  );
}

export default Calendar;
